<template>
  <shop-search starting-index="products:product__week_sold:desc" :show-buy-it-now="false" :show-collections="true" />
</template>

<script>
import StorefrontLayout from "@/layout/storefront-layout.vue";
import "@styles/shop/shop.scss";

// Not async: it is the whole page, which otherwise renders empty until its chunk arrives.
import ShopSearch from "@/shop/shop-search.vue";

export default {
  name: "Search",
  layout: StorefrontLayout,
  components: { ShopSearch },
};
</script>
